import axiosInstance from "./axiosInstance";

export async function enable({ flow } = {}) {
  const url = flow ? `/api/docusign/enable?flow=${encodeURIComponent(flow)}` : "/api/docusign/enable";
  const response = await axiosInstance.get(url);
  const redirectUrl = response.data?.redirect_url;
  if (redirectUrl) {
    window.location.href = redirectUrl;
  }
}

export async function disable() {
  const response = await axiosInstance.post("/api/docusign/disable");
  return response.data;
}


export async function getIntegrations() {
  const response = await axiosInstance.get("/api/integrations");
  return response.data;
}

export async function prepareForSignature(projectId, householdId, accountForms = null, firmDocs = null) {
  const response = await axiosInstance.post("/api/docusign/prepare-for-signature", {
    project_id: projectId,
    household_id: householdId,
    ...(accountForms ? { account_forms: accountForms } : {}),
    ...(firmDocs ? { firm_docs: firmDocs } : {}),
  }, { timeout: 120000 });
  return response.data;
}
